import ResourceHero from "./ResourceHero";

export default ResourceHero;
